/* =========================================================
   ALTAR DE LOS PELUDOS · Puromenu · Halloween 2026
   Formulario: foto + nombre + años + dedicatoria, captcha
   (Cloudflare Turnstile), compresión en el navegador, envío a
   la función "altar-submit" y tarjeta para compartir (1080x1920).
   Se abre con cualquier botón [data-pma-open="form"].
   ========================================================= */
(function () {
  'use strict';
  if (window.PMAltarFormLoaded) return;
  window.PMAltarFormLoaded = true;

  var TS_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var MAX_FULL = 2800000;
  var MAX_THUMB = 580000;
  var tsPromise = null;

  /* ---------- Utilidades ---------- */
  function fmt(t, map) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function slug(s) { return String(s || 'peludo').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'peludo'; }
  function cssVar(el, name, fallback) { var v = getComputedStyle(el).getPropertyValue(name).trim(); return v || fallback; }
  function validEmail(e) { return /^[^\s@"<>]+@[^\s@"<>]+\.[^\s@"<>]{2,}$/.test(e) && e.length <= 254; }

  /* ---------- Klaviyo (script de Klaviyo instalado en la tienda) ---------- */
  function klIsIdentified(ms) {
    var k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function') return Promise.resolve(false);
    var timeout = new Promise(function (r) { setTimeout(function () { r(false); }, ms); });
    var check = Promise.resolve().then(function () { return k.isIdentified(); }).then(function (v) { return v === true; }, function () { return false; });
    return Promise.race([check, timeout]);
  }
  function klTrack(name, props) {
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') { window.klaviyo.track(name, props); return true; }
      if (window._learnq && typeof window._learnq.push === 'function') { window._learnq.push(['track', name, props]); return true; }
    } catch (e) { /* nada */ }
    return false;
  }
  function klIdentify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') { window.klaviyo.identify({ email: email }); return; }
      if (window._learnq && typeof window._learnq.push === 'function') window._learnq.push(['identify', { $email: email }]);
    } catch (e) { /* nada */ }
  }
  function storageGet(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function storageSet(store, k, v) { try { window[store].setItem(k, v); } catch (e) { /* nada */ } }

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (tsPromise) return tsPromise;
    tsPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = TS_SRC;
      s.async = true;
      s.onload = function () {
        var tries = 0;
        (function wait() {
          if (window.turnstile) resolve(window.turnstile);
          else if (tries++ > 50) reject(new Error('Turnstile no disponible'));
          else setTimeout(wait, 100);
        })();
      };
      s.onerror = function () { tsPromise = null; reject(new Error('No se pudo cargar Turnstile')); };
      document.head.appendChild(s);
    });
    return tsPromise;
  }

  function loadImageFromFile(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var im = new Image();
      im.onload = function () { resolve(im); };
      im.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      im.src = url;
    });
  }

  function loadImageUrl(src) {
    return new Promise(function (resolve) {
      if (!src) { resolve(null); return; }
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { resolve(im); };
      im.onerror = function () { resolve(null); };
      im.src = src;
    });
  }

  function canvasToBlob(canvas, type, q) {
    return new Promise(function (resolve) { canvas.toBlob(function (b) { resolve(b); }, type, q); });
  }

  function encode(img, max, q) {
    var w = img.naturalWidth, h = img.naturalHeight;
    var r = Math.min(1, max / Math.max(w, h));
    var cw = Math.max(1, Math.round(w * r)), ch = Math.max(1, Math.round(h * r));
    var c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, cw, ch);
    ctx.drawImage(img, 0, 0, cw, ch);
    return canvasToBlob(c, 'image/webp', q).then(function (b) {
      if (b && b.type === 'image/webp') return b;
      return canvasToBlob(c, 'image/jpeg', q);
    });
  }

  function compress(img) {
    return encode(img, 1200, 0.85).then(function (full) {
      if (full && full.size > MAX_FULL) return encode(img, 1000, 0.7);
      return full;
    }).then(function (full) {
      return encode(img, 512, 0.8).then(function (thumb) {
        if (thumb && thumb.size > MAX_THUMB) return encode(img, 400, 0.65).then(function (t2) { return { full: full, thumb: t2 }; });
        return { full: full, thumb: thumb };
      });
    });
  }

  /* ---------- Tarjeta para compartir (canvas 1080x1920) ---------- */
  function wrapLines(ctx, text, maxW, maxLines) {
    var words = String(text || '').split(/\s+/), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = words[i]; }
      else line = test;
    }
    if (line) lines.push(line);
    if (lines.length > maxLines) {
      lines = lines.slice(0, maxLines);
      lines[maxLines - 1] = lines[maxLines - 1].replace(/\s*\S*$/, '') + '…';
    }
    return lines;
  }

  function fitFont(ctx, text, weight, size, family, maxW) {
    var s = size;
    do { ctx.font = weight + ' ' + s + 'px ' + family; s -= 4; } while (ctx.measureText(text).width > maxW && s > 36);
  }

  function spaced(ctx, px) { if ('letterSpacing' in ctx) ctx.letterSpacing = px + 'px'; }

  var FLAME = 'M12 2c1 3 4 4.5 4 8.5a4 4 0 0 1-8 0c0-1.5.7-2.6 1.5-3.3.2 1.5 1 2.3 1.8 2.3C11.3 7 11 4.5 12 2z';

  function roundRect(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  /* Diseño "Polaroid" (opción D del mockup). Medidas del mockup x2 (540x960 -> 1080x1920). */
  function drawCard(opts) {
    var W = 1080, H = 1920;
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d'), k = opts.colors, t = opts.texts;
    var hf = opts.headingFamily, hw = opts.headingWeight, bf = opts.bodyFamily, nf = opts.nameFamily;
    var name = opts.name || '';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';

    /* Fondo */
    ctx.fillStyle = k.bg;
    ctx.fillRect(0, 0, W, H);

    /* Guirnalda (imagen del Customizer) */
    if (opts.garland) {
      var gw = 1000, gh = opts.garland.naturalHeight * (gw / opts.garland.naturalWidth);
      try { ctx.drawImage(opts.garland, 40, 4, gw, gh); } catch (e) { /* imagen sin CORS */ }
    }

    /* Título */
    if (t.title) {
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,0.35)';
      ctx.shadowBlur = 24;
      ctx.shadowOffsetY = 4;
      ctx.fillStyle = k.title;
      fitFont(ctx, t.title, hw, 68, hf, 1000);
      ctx.fillText(t.title, W / 2, 273);
      ctx.restore();
    }

    /* Polaroid girada -3º */
    var px = 160, py = 404, pw = 760, ph = 923;
    var cx = px + pw / 2, cy = py + ph / 2;
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(-3 * Math.PI / 180);
    ctx.translate(-cx, -cy);

    ctx.save();
    ctx.shadowColor = 'rgba(42,16,51,0.25)';
    ctx.shadowBlur = 80;
    ctx.shadowOffsetY = 36;
    ctx.fillStyle = k.polaroid;
    roundRect(ctx, px, py, pw, ph, 12);
    ctx.fill();
    ctx.restore();

    var phx = px + 32, phy = py + 32, ps = 696;
    var im = opts.photo, iw = im.naturalWidth, ih = im.naturalHeight, side = Math.min(iw, ih);
    ctx.save();
    roundRect(ctx, phx, phy, ps, ps, 6);
    ctx.clip();
    ctx.drawImage(im, (iw - side) / 2, (ih - side) / 2, side, side, phx, phy, ps, ps);
    ctx.restore();

    var nameTop = phy + ps + 20;
    ctx.fillStyle = k.name;
    fitFont(ctx, name, '400', 92, nf, ps);
    ctx.fillText(name, cx, nameTop);

    if (opts.years) {
      ctx.fillStyle = k.years;
      ctx.font = '500 30px ' + bf;
      ctx.fillText(opts.years, cx, nameTop + 92 + 8 + 4);
    }

    if (opts.showTape) {
      ctx.save();
      ctx.translate(px + 380, py - 2);
      ctx.rotate(4 * Math.PI / 180);
      ctx.globalAlpha = 0.75;
      ctx.fillStyle = k.tape;
      ctx.fillRect(-100, -30, 200, 60);
      ctx.restore();
    }
    ctx.restore();

    /* Dedicatoria y frase */
    var y = 1372;
    if (opts.dedication) {
      ctx.fillStyle = k.text;
      ctx.font = '400 38px ' + bf;
      var lines = wrapLines(ctx, '\u201C' + opts.dedication + '\u201D', 840, 3);
      lines.forEach(function (l, i) { ctx.fillText(l, W / 2, y + i * 57 + 9); });
      y += lines.length * 57;
    }
    if (t.tagline) {
      y += opts.dedication ? 28 : 0;
      ctx.fillStyle = k.tagline;
      ctx.font = '700 26px ' + bf;
      spaced(ctx, 3.6);
      ctx.fillText(String(t.tagline).toUpperCase(), W / 2, y + 4);
      spaced(ctx, 0);
    }

    /* Botón "Enciende una vela" */
    var cta = fmt(t.cta, { nombre: name });
    if (cta) {
      ctx.font = '700 32px ' + bf;
      var tw = Math.min(ctx.measureText(cta).width, 820);
      var bw = tw + 32 + 16 + 88, bh = 90, bx = W / 2 - bw / 2, by = 1608;
      ctx.fillStyle = k.ctaBg;
      roundRect(ctx, bx, by, bw, bh, 45);
      ctx.fill();
      if (window.Path2D) {
        ctx.save();
        ctx.translate(bx + 44, by + 29);
        ctx.scale(32 / 24, 32 / 24);
        ctx.fillStyle = k.ctaText;
        ctx.fill(new Path2D(FLAME));
        ctx.restore();
      }
      ctx.fillStyle = k.ctaText;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.fillText(cta, bx + 44 + 32 + 16, by + bh / 2 + 1, 820);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
    }

    /* Logo y web */
    if (opts.logo) {
      var lw = 360, lh = opts.logo.naturalHeight * (lw / opts.logo.naturalWidth);
      if (lh > 110) { lh = 110; lw = opts.logo.naturalWidth * (lh / opts.logo.naturalHeight); }
      try { ctx.drawImage(opts.logo, W / 2 - lw / 2, 1734, lw, lh); } catch (e) { /* logo sin CORS */ }
    }
    if (t.url) {
      ctx.fillStyle = k.url;
      ctx.font = '400 28px ' + bf;
      ctx.fillText(t.url, W / 2, 1836);
    }
    return canvasToBlob(c, 'image/jpeg', 0.92);
  }

  /* =========================================================
     Formulario
     ========================================================= */
  function Form(root) {
    this.root = root;
    var cfgEl = root.querySelector('[data-pma-form-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    this.t = this.cfg.texts || {};
    this.el = root.querySelector('[data-pma-form-el]');
    this.file = root.querySelector('[data-pma-file]');
    this.preview = root.querySelector('[data-pma-preview]');
    this.previewIcon = root.querySelector('[data-pma-preview-icon]');
    this.photoTitle = root.querySelector('[data-pma-photo-title]');
    this.name = root.querySelector('[data-pma-name]');
    this.years = root.querySelector('[data-pma-years]');
    this.ded = root.querySelector('[data-pma-ded]');
    this.counter = root.querySelector('[data-pma-counter]');
    this.consent = root.querySelector('[data-pma-consent]');
    this.tsBox = root.querySelector('[data-pma-turnstile]');
    this.error = root.querySelector('[data-pma-error]');
    this.submit = root.querySelector('[data-pma-submit]');
    this.submitLabel = root.querySelector('[data-pma-submit-label]');
    this.views = { form: root.querySelector('[data-pma-view="form"]'), success: root.querySelector('[data-pma-view="success"]'), pending: root.querySelector('[data-pma-view="pending"]') };
    this.lead = this.cfg.lead || {};
    this.leadBox = root.querySelector('[data-pma-lead]');
    this.leadForm = root.querySelector('[data-pma-lead-form]');
    this.leadEmail = root.querySelector('[data-pma-lead-email]');
    this.leadConsent = root.querySelector('[data-pma-lead-consent]');
    this.leadError = root.querySelector('[data-pma-lead-error]');
    this.leadBtn = root.querySelector('[data-pma-lead-btn]');
    this.leadBtnLabel = root.querySelector('[data-pma-lead-btn-label]');
    this.leadTitle = root.querySelector('[data-pma-lead-title]');
    this.sent = root.querySelector('[data-pma-sent]');
    this.sentText = root.querySelector('[data-pma-sent-text]');
    this.token = null;
    this.widget = null;
    this.img = null;
    this.result = null;
    this.cardBlob = null;
    this.bind();
    this.updateLabel();
  }

  Form.prototype.show = function (name) {
    var v = this.views;
    Object.keys(v).forEach(function (k) { if (v[k]) v[k].hidden = k !== name; });
  };

  Form.prototype.open = function () {
    if (!this.placeholder) {
      this.placeholder = document.createComment('pma-form');
      this.root.parentNode.insertBefore(this.placeholder, this.root);
      document.body.appendChild(this.root);
    }
    this.root.hidden = false;
    document.documentElement.classList.add('pma-lock');
    this.renderTurnstile();
    var self = this;
    setTimeout(function () { var c = self.root.querySelector('[data-pma-form-close-btn]'); if (c) c.focus({ preventScroll: true }); }, 30);
  };

  Form.prototype.close = function () {
    this.root.hidden = true;
    if (!document.querySelector('.pma-app__stage.is-immersive')) document.documentElement.classList.remove('pma-lock');
    if (this.result) this.reset();
  };

  Form.prototype.reset = function () {
    this.el.reset();
    this.img = null;
    this.result = null;
    this.cardBlob = null;
    if (this.preview) { this.preview.hidden = true; this.preview.removeAttribute('src'); }
    if (this.previewIcon) this.previewIcon.hidden = false;
    if (this.photoTitle) this.photoTitle.textContent = this.t.photoTitle;
    this.counter.textContent = '0';
    this.setError('');
    this.closeLead();
    this.unlock();
    if (this.sent) this.sent.hidden = true;
    this.updateLabel();
    this.show('form');
  };

  Form.prototype.renderTurnstile = function () {
    var self = this;
    if (this.widget !== null || !this.cfg.turnstileKey || !this.tsBox) return;
    this.widget = 'loading';
    loadTurnstile().then(function (ts) {
      self.widget = ts.render(self.tsBox, {
        sitekey: self.cfg.turnstileKey,
        appearance: 'interaction-only',
        language: 'es',
        callback: function (tok) { self.token = tok; },
        'expired-callback': function () { self.token = null; },
        'error-callback': function () { self.token = null; }
      });
    }).catch(function (err) {
      self.widget = null;
      console.error('[Altar] ' + err.message);
    });
  };

  Form.prototype.resetTurnstile = function () {
    this.token = null;
    if (window.turnstile && this.widget && this.widget !== 'loading') {
      try { window.turnstile.reset(this.widget); } catch (e) { /* nada */ }
    }
  };

  Form.prototype.waitToken = function (ms) {
    var self = this, start = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        if (self.token) resolve(self.token);
        else if (Date.now() - start > ms) resolve(null);
        else setTimeout(check, 200);
      })();
    });
  };

  Form.prototype.setError = function (msg) {
    this.error.textContent = msg || '';
    this.error.hidden = !msg;
  };

  Form.prototype.updateLabel = function () {
    var n = (this.name.value || '').trim();
    this.submitLabel.textContent = fmt(this.t.submit, { nombre: n || this.t.submitFallback });
  };

  Form.prototype.busy = function (on) {
    this.submit.disabled = on;
    if (on) this.submitLabel.textContent = this.t.sending;
    else this.updateLabel();
  };

  Form.prototype.pickFile = function () {
    var self = this, f = this.file.files && this.file.files[0];
    if (!f) return;
    this.setError('');
    loadImageFromFile(f).then(function (im) {
      self.img = im;
      self.preview.src = im.src;
      self.preview.hidden = false;
      if (self.previewIcon) self.previewIcon.hidden = true;
      if (self.photoTitle) self.photoTitle.textContent = self.t.photoChange;
    }).catch(function () {
      self.img = null;
      self.file.value = '';
      self.setError(self.t.errBadImage);
    });
  };

  Form.prototype.send = function () {
    var self = this, t = this.t;
    var name = (this.name.value || '').trim();
    if (!this.img) { this.setError(t.errNoPhoto); return; }
    if (!name) { this.setError(t.errNoName); this.name.focus(); return; }
    if (!this.consent.checked) { this.setError(t.errNoConsent); return; }
    if (!this.cfg.functionUrl || !this.cfg.turnstileKey) { this.setError(t.errConfig); return; }
    this.setError('');
    this.busy(true);

    var files;
    compress(this.img).then(function (r) {
      files = r;
      if (!r.full || !r.thumb) throw { msg: t.errBadImage };
      return self.waitToken(10000);
    }).then(function (token) {
      if (!token) throw { msg: t.errCaptcha };
      var fd = new FormData();
      var ext = files.full.type === 'image/webp' ? 'webp' : 'jpg';
      var extT = files.thumb.type === 'image/webp' ? 'webp' : 'jpg';
      fd.append('pet_name', name);
      fd.append('years', (self.years.value || '').trim());
      fd.append('dedication', (self.ded.value || '').trim());
      fd.append('consent', 'true');
      fd.append('turnstile_token', token);
      fd.append('image', files.full, 'full.' + ext);
      fd.append('thumb', files.thumb, 'thumb.' + extT);
      return fetch(self.cfg.functionUrl, { method: 'POST', body: fd });
    }).then(function (res) {
      return res.json().catch(function () { return { ok: false, message: t.errNetwork }; });
    }).then(function (data) {
      self.resetTurnstile();
      if (!data || !data.ok) throw { msg: (data && data.message) || t.errNetwork };
      self.result = data;
      if (data.status === 'approved' && data.pet) return self.success(data.pet);
      self.pending(name);
    }).catch(function (err) {
      self.resetTurnstile();
      if (!(err && err.msg)) console.error('[Altar] Error al enviar:', err);
      self.setError((err && err.msg) || t.errNetwork);
    }).then(function () {
      self.busy(false);
    });
  };

  Form.prototype.pending = function (name) {
    var v = this.views.pending;
    v.querySelector('[data-pma-pending-title]').textContent = fmt(this.t.pendingTitle, { nombre: name });
    this.show('pending');
  };

  Form.prototype.success = function (pet) {
    var self = this, t = this.t, v = this.views.success;
    this.pet = pet;
    if (window.PMAltar && window.PMAltar.add) {
      window.PMAltar.add({ id: pet.id, pet_name: pet.pet_name, years: pet.years, dedication: pet.dedication, image_path: pet.image_url, thumb_path: pet.thumb_url, candles: 0 });
    }
    v.querySelector('[data-pma-success-title]').textContent = fmt(t.successTitle, { nombre: pet.pet_name });
    var viewBtn = v.querySelector('[data-pma-view-label]');
    if (viewBtn) viewBtn.textContent = fmt(t.viewInAltar, { nombre: pet.pet_name });
    var cardImg = v.querySelector('[data-pma-card]');
    cardImg.removeAttribute('src');
    if (this.sent) this.sent.hidden = true;
    var useLead = this.lead.enabled && this.lead.functionUrl;
    if (useLead) v.classList.add('is-locked');
    this.show('success');

    var cardReady = this.makeCard(pet).then(function (blob) {
      self.cardBlob = blob;
      if (blob) cardImg.src = URL.createObjectURL(blob);
      return blob;
    });
    if (!useLead) return cardReady;

    /* 1) ¿Sabemos quién es? (sesión de Shopify o Klaviyo lo identifica en este navegador) */
    var who = this.lead.customerEmail
      ? Promise.resolve({ email: this.lead.customerEmail })
      : klIsIdentified(1500).then(function (ok) { return ok ? { identified: true } : {}; });

    return Promise.all([cardReady, who]).then(function (res) {
      var blob = res[0], w = res[1];
      if (!blob) { self.unlock(); return; }
      if (w.email) {
        self.unlock();
        return self.sendCard({ email: w.email, consent: false }).then(function (ok) { self.showSent(ok); });
      }
      if (w.identified) {
        self.unlock();
        return self.sendCard({ identified: true }).then(function (ok) { self.showSent(ok); });
      }
      /* 2) No le conocemos: pedimos el email para enviarle la tarjeta */
      if (storageGet('sessionStorage', 'pma_lead_skip') === '1') { self.unlock(); return; }
      self.openLead();
    });
  };

  Form.prototype.unlock = function () {
    if (this.views.success) this.views.success.classList.remove('is-locked');
  };

  Form.prototype.showSent = function (ok) {
    if (!this.sent || !this.pet) return;
    this.sentText.textContent = fmt(ok ? this.lead.sentText : this.lead.sendError, { nombre: this.pet.pet_name });
    this.sent.classList.toggle('is-error', !ok);
    this.sent.hidden = false;
  };

  /* Sube la tarjeta y la envía por email (Klaviyo). Devuelve true si todo fue bien. */
  Form.prototype.sendCard = function (opts) {
    var self = this, lead = this.lead;
    if (!this.cardBlob || !this.pet) return Promise.resolve(false);
    var fd = new FormData();
    fd.append('pet_id', this.pet.id);
    fd.append('card', this.cardBlob, 'card.jpg');
    fd.append('altar_url', this.petUrl());
    if (opts.email) {
      fd.append('email', opts.email);
      fd.append('consent', opts.consent ? 'true' : 'false');
    }
    return fetch(lead.functionUrl, { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (data) {
        if (!data || !data.ok) { console.error('[Altar] No se pudo enviar la tarjeta:', data && data.code); return false; }
        if (opts.identified) {
          var props = data.props || { pet_name: self.pet.pet_name, card_url: data.card_url, altar_url: self.petUrl() };
          return klTrack(lead.eventName, props);
        }
        return true;
      })
      .catch(function (err) { console.error('[Altar] Error al enviar la tarjeta:', err); return false; });
  };

  /* ---------- Popup: "¿Dónde te enviamos la tarjeta?" ---------- */
  Form.prototype.openLead = function () {
    if (!this.leadBox) { this.unlock(); return; }
    this.leadForm.reset();
    this.setLeadError('');
    this.leadTitle.textContent = fmt(this.lead.title, { nombre: this.pet.pet_name });
    this.leadBtn.disabled = false;
    this.leadBtnLabel.textContent = this.lead.btn;
    this.leadBox.hidden = false;
    var em = this.leadEmail;
    setTimeout(function () { try { em.focus({ preventScroll: true }); } catch (e) { /* nada */ } }, 60);
  };

  Form.prototype.closeLead = function () {
    if (this.leadBox) this.leadBox.hidden = true;
  };

  Form.prototype.setLeadError = function (msg) {
    if (!this.leadError) return;
    this.leadError.textContent = msg || '';
    this.leadError.hidden = !msg;
  };

  Form.prototype.submitLead = function () {
    var self = this, lead = this.lead;
    var email = (this.leadEmail.value || '').trim().toLowerCase();
    if (!validEmail(email)) { this.setLeadError(lead.errEmail); this.leadEmail.focus(); return; }
    this.setLeadError('');
    this.leadBtn.disabled = true;
    this.leadBtnLabel.textContent = lead.sending;
    var consent = !!(this.leadConsent && this.leadConsent.checked);
    this.sendCard({ email: email, consent: consent }).then(function (ok) {
      if (ok) klIdentify(email);
      self.closeLead();
      self.unlock();
      self.showSent(ok);
    });
  };

  Form.prototype.skipLead = function () {
    storageSet('sessionStorage', 'pma_lead_skip', '1');
    this.closeLead();
    this.unlock();
  };

  Form.prototype.makeCard = function (pet) {
    var self = this, c = this.cfg.card || {}, root = this.root;
    var hf = cssVar(root, '--pma-heading-family', 'sans-serif');
    var hw = cssVar(root, '--pma-heading-weight', '500');
    var bf = cssVar(root, '--pma-body-family', 'sans-serif');
    var nf = c.nameFont === 'heading' ? hf : "'GochiHand', 'Gochi Hand', cursive";
    var fontsReady = (document.fonts && document.fonts.load)
      ? Promise.all([
          document.fonts.load(hw + ' 68px ' + hf),
          document.fonts.load('400 92px ' + nf),
          document.fonts.load('700 30px ' + bf),
          document.fonts.load('400 30px ' + bf),
          document.fonts.load('500 30px ' + bf)
        ]).catch(function () {})
      : Promise.resolve();
    var timeout = new Promise(function (r) { setTimeout(r, 2500); });
    return Promise.all([Promise.race([fontsReady, timeout]), loadImageUrl(c.logo), loadImageUrl(c.garland)]).then(function (res) {
      return drawCard({
        photo: self.img,
        logo: res[1],
        garland: res[2],
        showTape: c.showTape !== false,
        name: pet.pet_name,
        years: pet.years,
        dedication: pet.dedication,
        headingFamily: hf, headingWeight: hw, bodyFamily: bf, nameFamily: nf,
        texts: c.texts || {},
        colors: c.colors || {}
      });
    }).catch(function (err) {
      console.error('[Altar] Error al crear la tarjeta:', err);
      return null;
    });
  };

  Form.prototype.petUrl = function () {
    var base = this.cfg.altarUrl || (window.location.origin + window.location.pathname);
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'peludo=' + encodeURIComponent(this.pet.id);
  };

  Form.prototype.shareCard = function () {
    var self = this, t = this.t;
    if (!this.cardBlob || !this.pet) return;
    var file = new File([this.cardBlob], 'altar-' + slug(this.pet.pet_name) + '.jpg', { type: 'image/jpeg' });
    var text = fmt(t.shareText, { nombre: this.pet.pet_name }) + ' ' + this.petUrl();
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      navigator.share({ files: [file], title: this.pet.pet_name, text: text }).catch(function () { /* cancelado */ });
    } else if (navigator.share) {
      navigator.share({ title: this.pet.pet_name, text: text, url: this.petUrl() }).catch(function () { /* cancelado */ });
    } else {
      self.download();
    }
  };

  Form.prototype.download = function () {
    if (!this.cardBlob || !this.pet) return;
    var a = document.createElement('a');
    a.href = URL.createObjectURL(this.cardBlob);
    a.download = 'altar-' + slug(this.pet.pet_name) + '.jpg';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  };

  Form.prototype.copy = function (btn) {
    var url = this.petUrl(), t = this.t;
    var label = btn && btn.querySelector('span');
    function done() { if (label) label.textContent = t.copied; }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
    else window.prompt('', url);
  };

  Form.prototype.bind = function () {
    var self = this;
    this.file.addEventListener('change', function () { self.pickFile(); });
    this.name.addEventListener('input', function () { self.updateLabel(); });
    this.ded.addEventListener('input', function () { self.counter.textContent = String(self.ded.value.length); });
    this.el.addEventListener('submit', function (e) { e.preventDefault(); if (!self.submit.disabled) self.send(); });
    if (this.leadForm) {
      this.leadForm.addEventListener('submit', function (e) { e.preventDefault(); if (!self.leadBtn.disabled) self.submitLead(); });
    }
    this.root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pma-f]');
      if (!a) return;
      var act = a.getAttribute('data-pma-f');
      if (act === 'close') self.close();
      else if (act === 'share') self.shareCard();
      else if (act === 'download') self.download();
      else if (act === 'copy') self.copy(a);
      else if (act === 'lead-skip') self.skipLead();
      else if (act === 'view') {
        var id = self.pet && self.pet.id;
        self.close();
        if (id && window.PMAltar && window.PMAltar.show) window.PMAltar.show(id);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !self.root.hidden) {
        e.stopPropagation();
        if (self.leadBox && !self.leadBox.hidden) self.skipLead();
        else self.close();
      }
    }, true);
  };

  /* ---------- Arranque ---------- */
  var form = null;
  function init() {
    if (form) return;
    var node = document.querySelector('[data-pma-form]');
    if (!node) return;
    try { form = new Form(node); } catch (err) { console.error('[Altar] No se pudo iniciar el formulario:', err); }
  }
  document.addEventListener('pma:open-form', function () { init(); if (form) form.open(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pma-open="form"]');
    if (!t) return;
    e.preventDefault();
    init();
    if (form) form.open();
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-pma-form]')) { form = null; init(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();